// extracted by mini-css-extract-plugin
export default {"card":"detail_card__CK1ad","cardTitle":"detail_cardTitle__YWq53","tile":"detail_tile__blGxO","tileLabel":"detail_tileLabel__GR2Mx","mono":"detail_mono__VS7B-"};